<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-toc" id="table-of-contents">
<div class="heading heading-container-single heading-size-small heading-format-reduced heading-alignment-fixed heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper">CONTENTS</h1>
</div>
</div>
</div>
</div>
<div class="toc-contents text">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/foreword"><span class="toc-item-title-text">Foreword</span></a></p>
<p class="toc-content toc-item-author">D.P. Benjamin</p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/introduction"><span class="toc-item-title-text">Introduction</span></a></p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">1. </span><a href="#/chapter001"><span class="toc-item-title-text">The Princess And The Others</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">2. </span><a href="#/chapter002"><span class="toc-item-title-text">The Sailor’s Star</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">3. </span><a href="#/chapter003"><span class="toc-item-title-text">The Comet And The Pole Star</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">4. </span><a href="#/chapter004"><span class="toc-item-title-text">Old Sol’s Menagerie</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">5. </span><a href="#/chapter005"><span class="toc-item-title-text">Major</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">6. </span><a href="#/chapter006"><span class="toc-item-title-text">The Bee Baby</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">7. </span><a href="#/chapter007"><span class="toc-item-title-text">Lady Moon’s Lantern</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">8. </span><a href="#/chapter008"><span class="toc-item-title-text">Andromeda’s Birthday</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">9. </span><a href="#/chapter009"><span class="toc-item-title-text">A Surprise Party</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">10. </span><a href="#/chapter010"><span class="toc-item-title-text">Travelers’ Tales</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">11. </span><a href="#/chapter011"><span class="toc-item-title-text">Torquillon’s Lair</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span href="#/epilogue" title="Link target outside of Sample"><span class="toc-item-title-text">Epilogue</span></span></p>
</div>
<div class="toc-group toc-group-part">
<div class="toc-item toc-item-entry-type-part toc-item-element-container-group has-no-leading-number has-no-author has-children">
<p class="toc-content toc-item-title"><a href="#/upart001"><span class="toc-item-title-text">First Edition Artwork</span></a></p>
</div>
<div class="toc-item-children">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">1. </span><a href="#/upart001chapter001"><span class="toc-item-title-text">First Edition Cover</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">2. </span><a href="#/upart001chapter002"><span class="toc-item-title-text">Drop Caps</span></a></p>
</div>
</div>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/publishersnote"><span class="toc-item-title-text">Publisher’s Note</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/abouttheauthor"><span class="toc-item-title-text">About the Author</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/abouttheillustrator"><span class="toc-item-title-text">About the Illustrator</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/abouttheforewordauthor"><span class="toc-item-title-text">About The Foreword Author</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/abouttheeditor"><span class="toc-item-title-text">About the Editor</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/wordfireclassics"><span class="toc-item-title-text">WordFire Classics</span></a></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0e392e02